<template>
  <div class="border-[1px] border-[#E1E1E1] rounded-[10px] bg-white p-4">
    <ul class="border-b border-b-[#E1E1E1] pb-4">
      <li
        v-for="orderItem in orderList"
        :key="orderItem.priceId"
        class="flex gap-10 p-2 justify-between"
      >
        <div class="flex gap-4">
          <figure
            class="shrink-0 md:w-[88px] md:h-[71px] w-[70px] h-[56px] bg-white rounded-[10px]"
          >
            <img
loading="lazy"
              :src="getImage(orderItem.image.url)"
              :alt="orderItem.image.name"
              class="object-contain w-full h-full"
            />
          </figure>
          <p class="text-[14px] md:text-[16px] text-black">
            {{ orderItem.fullName }}
          </p>
        </div>
        <div class="flex flex-col gap-[5px] shrink-0">
          <p class="text-[17px] md:text-[18px] font-bold">
            {{ orderItem.totalPrice.value }}
            {{ orderItem.totalPrice.currencyIso }}
          </p>
          <p class="text-[14px] text-right text-[#8E8E8E] font-normal">
            {{ $t("checkout.quantity", orderItem.quantity) }}
          </p>
        </div>
      </li>
    </ul>
    <div class="pt-4 text-end">
      <div class="flex flex-col gap-[5px]">
        <p class="text-[18px] font-bold">
          {{ totalPrice.value }}
          {{ totalPrice.currencyIso }}
        </p>
        <p class="text-[14px] text-right text-[#1F1F1F] font-normal">
          {{ $t("checkout.cost-of-goods") }}
        </p>
      </div>
    </div>
  </div>
</template>

<script setup>
import {computed} from "vue";
import {useCartStore} from "@/stores/cartStore";
import {getImage} from "@/services/getImage";

const cartStore = useCartStore();

const orderList = computed(() => cartStore.getOrderList);
const totalPrice = computed(() => cartStore.getTotalPrice);
</script>
